<script setup>
import {ref, defineProps, defineEmits, watchEffect, defineModel} from "vue";
import GoogleFilesSearch from "@/components/GoogleModal/GoogleFilesSearch.vue";
import GoogleFiles from "@/components/GoogleModal/GoogleFiles.vue";

import {Api} from "@/service/api";

const tables = ref([])
const folders = ref([])

const fileTypes = ['application/vnd.google-apps.spreadsheet', 'application/vnd.google-apps.folder']

const sharedWithMe = ref(false)
const starredFiles = ref(false)
const orderBy = ref("name_natural")
const desc = ref(false)
const nextPageToken = ref("")
const folderId = ref("")
const searchString = ref("")
const isRefresh = ref(false)

const selectedTables = defineModel('tables')


const isLoading = ref(true);
const isLoadingMore = ref(false);


const props = defineProps({
    connectionType: {
        required: true,
        type: String,
    },
    multiSelect: {
        type: Boolean,
        required: true,
    }
})

watchEffect(async () => {
    isLoading.value = true

    const response_folders = await Api.getGoogleDriveFiles(
        fileTypes[1],
        sharedWithMe.value,
        starredFiles.value,
        orderBy.value,
        desc.value,
        "",
        folderId.value,
        searchString.value,
        isRefresh.value,
    );

    if (response_folders.error === 403) {
        return
    }

    folders.value = response_folders.files

    const response_tables = await Api.getGoogleDriveFiles(
        fileTypes[0],
        sharedWithMe.value,
        starredFiles.value,
        orderBy.value,
        desc.value,
        "",
        folderId.value,
        searchString.value,
        isRefresh.value,
    );

    if (response_tables.error === 403) {
        return
    }


    tables.value = response_tables.files;
    nextPageToken.value = response_tables.nextPageToken

    isLoading.value = false
    isRefresh.value = false
})

watchEffect(() => {
    if (selectedTables.value?.length > 0) {
        for (const table of tables.value) {
            for (const _table of selectedTables.value) {
                if (table.id === _table.id) {
                    table.isChecked = true
                }
            }
        }
    }
})


const emit = defineEmits(["submit", "close-window", 'submitFilesSaving']);

function updateSearchString(newString) {
    searchString.value = newString
}

function refreshTables() {
    isRefresh.value = true
}

function submitFilesSaving(values) {
    emit("submitFilesSaving", values)
}

async function loadMore() {
    isLoadingMore.value = true
    const response_folders = await Api.getGoogleDriveFiles(
        fileTypes[0],
        sharedWithMe.value,
        starredFiles.value,
        orderBy.value,
        desc.value,
        nextPageToken.value,
        folderId.value,
        searchString.value,
        isRefresh.value,
    );

    tables.value = tables.value.concat(response_folders.files);
    nextPageToken.value = response_folders.nextPageToken;
    isLoadingMore.value = false

}

function closeWindow() {
    emit('close-window')
}


</script>

<template>
    <div class="w-full h-full flex flex-col">
        <GoogleFilesSearch
            class="h-1/5"
            @update-string="updateSearchString"
            @refresh="refreshTables"
            :is-loading="isLoading"
            v-model:is-starred="starredFiles"
            v-model:is-shared="sharedWithMe"
            @close-window="closeWindow"
        />
        <div class="h-4/5">
            <GoogleFiles
                v-model:tables="tables"
                v-model:folders="folders"
                v-model:desc="desc"
                v-model:folder-id="folderId"
                v-model:order-by="orderBy"
                :next-page-token="nextPageToken"
                :is-loading="isLoading"
                :is-loading-more="isLoadingMore"
                :connection-type="props.connectionType"
                :search="searchString"
                @submit="emit('submit')"
                @submit-files-saving="submitFilesSaving"
                @load-more="loadMore"
                class="h-full"
                :multi-select="props.multiSelect"
            />
        </div>
    </div>
</template>
